import styled from "@emotion/styled";

export const JobInfoRoot = styled.div`
  padding: 2rem;
`;

export const JobInfoHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const JobSchedulerInfo = styled.div`
  display: flex;
  align-items: center;
`;
